import { render, staticRenderFns } from "./SidebarSaleRowsBlock.vue?vue&type=template&id=6d2fcba9&scoped=true"
import script from "./SidebarSaleRowsBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarSaleRowsBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarSaleRowsBlock.vue?vue&type=style&index=0&id=6d2fcba9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2fcba9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2fcba9')) {
      api.createRecord('6d2fcba9', component.options)
    } else {
      api.reload('6d2fcba9', component.options)
    }
    module.hot.accept("./SidebarSaleRowsBlock.vue?vue&type=template&id=6d2fcba9&scoped=true", function () {
      api.rerender('6d2fcba9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarSaleRowsBlock.vue"
export default component.exports